import React from 'react';

interface CircleIconProps {
  className?: string;
  size?: number;
}

export const CircleIcon: React.FC<CircleIconProps> = ({ 
  className = "w-5 h-5", 
  size = 20 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Main circle with organic feel */}
      <circle
        cx="12"
        cy="12"
        r="8"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Inner circle detail */}
      <circle
        cx="12"
        cy="12"
        r="4"
        stroke="currentColor"
        strokeWidth="0.5"
        fill="none"
        opacity="0.4"
      />
      {/* Subtle center point */}
      <circle
        cx="12"
        cy="12"
        r="1"
        fill="currentColor"
        opacity="0.6"
      />
      {/* Organic curve accent */}
      <path
        d="M4 12a8 8 0 0 1 16 0"
        stroke="currentColor"
        strokeWidth="0.5"
        opacity="0.3"
        strokeDasharray="1 1"
      />
    </svg>
  );
};

export default CircleIcon;
